import type {Expand} from '../types';

export const foodDiaryExpandCommon: Expand = {
  food_diary: ['attachment_ids'],
};
